export default {
  id: 'imagine.pairing.SelectPairSummary',
  type: 'imagine.pairing.SelectPairSummary',
  perform: context => {
    const {
      setActiveStep
    } = context;
    setActiveStep('pairSummary');
  }
};